<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">
                    {{ translations.detailsInfo }}
                  </h2>
                  <p class="card-big-info-desc">
                    {{ translations.details }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.title.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >{{ translations.forms.labels.title }}</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.title"
                        v-model="title"
                      />

                      <form-error
                        :model="$v.title"
                        :label="translations.forms.labels.title"
                        :dirty="$v.$dirty"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.displayName.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >{{ translations.forms.labels.displayName }}</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.displayName"
                        v-model="displayName"
                      />

                      <form-error
                        :model="$v.displayName"
                        :label="translations.forms.labels.displayName"
                        :dirty="$v.$dirty"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >{{ translations.forms.labels.description }}</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        :placeholder="translations.forms.labels.description"
                        v-model="description"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.attributeStyle.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.attributeType }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="attributeStyle"
                      >
                        <option
                          :value="item.id"
                          v-for="item in attributeStyles"
                          :key="item.id"
                        >
                          {{ item.label }}
                        </option>
                      </select>

                      <form-error
                        :model="$v.attributeStyle"
                        :label="translations.forms.labels.attributeType"
                        :dirty="$v.$dirty"
                      />
                    </div>
                  </div>

                <div class="form-group row align-items-center pb-3">
                  <label
                    class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                  >
                    Poveži s artiklom?
                  </label>
                  <div class="col-lg-7 col-xl-6">
                    <div class="checkbox-custom checkbox-default">
                      <input
                        type="checkbox"
                        v-model="linkWithArticle"
                        id="link-with-article"
                      />
                      <label for="link-with-article"></label>
                    </div>
                  </div>
                </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.attributeProperties.$anyError }"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      {{ translations.forms.labels.availableValues }}
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <draggable
                        :list="attributeProperties"
                        :disabled="false"
                        class="list-group"
                        ghost-class="ghost"
                        tag="ul"
                        handle=".handle"
                        @start="dragging = true"
                        @end="dragging = false"
                      >
                        <li
                          class="list-group-item"
                          v-for="(element, index) in attributeProperties"
                          :key="index"
                        >
                          <i class="fa fa-align-justify handle"></i>
                          <input
                            type="text"
                            class="form-control"
                            v-model="element.title"
                            v-if="attributeStyle !== 1"
                          />
                          <v-swatches
                            v-model="colors[index]"
                            v-else
                            swatches="text-advanced"
                          ></v-swatches>
                          <i
                            class="fa fa-times close"
                            :class="{ color: attributeStyle === 1 }"
                            @click="removeAt(index)"
                          ></i>
                        </li>
                      </draggable>

                      <form-error
                        :model="$v.attributeProperties"
                        :label="translations.forms.labels.availableValues"
                        :dirty="$v.$dirty"
                      />

                      <button
                        class="btn btn-primary py-3 mt-2 align-items-center font-weight-semibold line-height-1"
                        @click.prevent.stop="add()"
                      >
                        Add new
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <router-link
            exact
            :to="{ name: 'Attributes' }"
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import VSwatches from 'vue-swatches';
// Import the styles too, typically in App.vue or main.js
import 'vue-swatches/dist/vue-swatches.css';

import draggable from 'vuedraggable';
import api from '@/services/api';
import { translations } from '@/mixins';
import validations from './validation-schema/add';
import FormError from '../shared/form-errors/FormError.vue';

export default {
  name: 'AddAttribute',
  components: { draggable, FormError, VSwatches },
  mixins: [translations],
  validations,
  data() {
    return {
      attributeStyles: [
        {
          id: 1,
          label: 'Boja'
        },
        {
          id: 2,
          label: 'Velicina odjeće'
        },
        {
          id: 3,
          label: 'Ostalo'
        }
      ],
      colors: [''],
      attributeStyle: 3,
      title: '',
      displayName: '',
      description: '',
      attributeProperties: [
        {
          title: '',
          order: 1
        }
      ],
      linkWithArticle: false
    };
  },
  computed: {
    isFormValid() {
      return !this.$v.$invalid;
    }
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      if (!this.isFormValid) {
        this.$toast.error(this.translations.forms.notValid);
        return;
      }

      this.attributeProperties = this.attributeProperties.map((item, index) => {
        const title =
          this.attributeStyle === 1 ? this.colors[index] : item.title;
        return {
          ...item,
          title,
          order: index + 1
        };
      });

      const { title, description, attributeProperties, attributeStyle, displayName } = this;

      api
        .createAttribute({
          title,
          displayName,
          description,
          attributeProperties,
          attributeStyle
        })
        .then(response => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Attributes' });
        })
        .catch(err => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    add() {
      if (this.attributeStyle === 1) {
        this.attributeProperties.push({
          order: this.attributeProperties.length + 1
        });
        this.colors.push('');
      } else {
        this.attributeProperties.push({
          title: '',
          order: this.attributeProperties.length + 1
        });
      }
    },
    removeAt(id) {
      this.attributeProperties.splice(id, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.button {
  margin-top: 35px;
}
.handle {
  margin-right: 15px;
}
.close {
  float: right;
  padding-top: 8px;
  padding-bottom: 8px;
}

.list-group-item {
  display: flex;
  align-items: center;
}

.close {
  margin-left: 15px;

  &.color {
    position: absolute;
    right: 15px;
  }
}
</style>
